
import React from 'react';

interface SearchResultHighlightProps {
  text: string;
  searchQuery: string;
  className?: string;
}

export const SearchResultHighlight: React.FC<SearchResultHighlightProps> = ({
  text,
  searchQuery,
  className = ''
}) => {
  if (!searchQuery || !text) {
    return <span className={className}>{text}</span>;
  }

  const parts = text.split(new RegExp(`(${searchQuery})`, 'gi'));
  
  return (
    <span className={className}>
      {parts.map((part, index) => 
        part.toLowerCase() === searchQuery.toLowerCase() ? (
          <mark key={index} className="bg-white dark:bg-slate-800 px-1 rounded">
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  );
};
